<script>
export default {
  name: 'MoreAffordableIcon',
}
</script>
<template>
  <svg width="56px" height="48px" viewBox="0 0 56 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
      <title>ic_more-affordable</title>
      <g id="Design" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round">
          <g id="Desktop-HD-2-Rev" transform="translate(-284.000000, -2354.000000)" stroke="#FFFFFF">
              <g id="Benefits" transform="translate(0.000000, 1597.000000)">
                  <g id="Proofpoints" transform="translate(252.000000, 726.000000)">
                      <g id="ic_more-affordable" transform="translate(33.000000, 32.000000)">
                          <g>
                              <path d="M37,18.5 C37,17.118 38.118,16 39.5,16 C40.882,16 42,17.118 42,18.5" id="Stroke-1" stroke-width="2"></path>
                              <path d="M4,25 C1.791,25 0,23.209 0,21" id="Stroke-3" stroke-width="2"></path>
                              <path d="M29.8994,6 C30.0344,5.335 30.0404,4.624 29.8774,3.891 C29.4504,1.977 27.8784,0.442 25.9504,0.087 C22.7714,-0.498 20.0004,1.928 20.0004,5 C20.0004,5.342 20.0354,5.677 20.1004,6" id="Stroke-5" stroke-width="2"></path>
                              <path d="M49.6885,28 C48.4945,33.875 43.8765,38.506 38.0005,39.699 L38.0005,44 C38.0005,45.104 37.1045,46 36.0005,46 L34.0005,46 C32.8955,46 32.0005,45.104 32.0005,44 L32.0005,40 L19.0005,40 C17.9725,40 16.9685,39.896 16.0005,39.699 L16.0005,44 C16.0005,45.104 15.1045,46 14.0005,46 L12.0005,46 C10.8955,46 10.0005,45.104 10.0005,44 L10.0005,36.979 C6.4015,34.271 4.0495,29.992 4.0005,25.153 C3.9175,16.818 11.1015,10 19.4375,10 L32.8445,10 C33.2535,10 33.6085,9.744 33.7735,9.37 C35.1685,6.209 38.3235,4 42.0005,4 L42.0005,11.768 C44.6575,13.176 46.8475,15.345 48.2565,18 L53.0005,18 C53.5525,18 54.0005,18.448 54.0005,19 L54.0005,25 C54.0005,26.657 52.6575,28 51.0005,28 L48.0005,28" id="Stroke-7" stroke-width="2"></path>
                          </g>
                      </g>
                  </g>
              </g>
          </g>
      </g>
  </svg>
</template>
